import { localize } from 'pseudo-localization';

export const pseudolocalize = text => {
  if (
    text.includes('<table') ||
    text.includes('<Pdf') ||
    text.includes('<Download')
  ) {
    return text;
  } else {
    return localize(text);
  }
};
